import { render, staticRenderFns } from "./OneTimeCodeDestination.vue?vue&type=template&id=5e892f4c&"
import script from "./OneTimeCodeDestination.vue?vue&type=script&lang=js&"
export * from "./OneTimeCodeDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports